// export const API = 'http://localhost:4000/api';
// export const API = 'http://15.206.179.157:4000/api';  //15.206.179.157 brainbench on new portal
export const API = 'https://brainbench.jaipuria.edu.in/api';  //15.206.179.157 brainbench on new portal